<template>
	<div>
		<q-table
			ref="table"
			:data="tests"
			:columns="columns_tests"
			row-key="id"
			:pagination.sync="pagination_tests"
			@request="requestTests"
			:loading="loading"
			:no-data-label="$t('no_data_avaliable')"
			:no-results-label="$t('no_results_found')"
			:loading-label="$t('loading_data')"
			:rows-per-page-label="$t('items_per_page')"
			:rows-per-page-options="[5, 10, 50, 100]"
			binary-state-sort
			class="q-mt-lg"
		>
			<q-tr slot="header" slot-scope="props" :props="props">
				<q-th v-for="col in props.cols" :key="col.name" :props="props">
					{{ $t(col.label) }}
				</q-th>
			</q-tr>

			<template slot="body" slot-scope="props">
				<q-tr :props="props">
					<q-td key="title" :props="props">
						<span v-if="props.row.title.length > 49">
							{{ `${props.row.title.substring(0, 50)}...` }}
							<q-tooltip>{{ props.row.title }}</q-tooltip>
						</span>
						<span v-else>
							{{ props.row.title }}
						</span>
					</q-td>

					<q-td key="qty_questions" :props="props">
						{{ props.row.qty_questions }}
					</q-td>

					<q-td key="qty_user_results" :props="props">
						{{ props.row.qty_user_results }}
					</q-td>

					<q-td key="status" :props="props" auto-width>
						<q-chip
							small
							:icon="getIconStatusTest(props.row.status)"
							:color="getColorStatusTest(props.row.status)"
							class="full-width text-center"
						>
							{{ $t(getTextStatusTest(props.row.status)) }}
						</q-chip>
					</q-td>

					<q-td auto-width key="actions" :props="props">
						<q-btn
							flat
							round
							color="secondary"
							icon="fas fa-users"
							@click="showTestUsers(props.row)"
						>
							<q-tooltip>
								{{ $t('participants_report_tooltip') }}
							</q-tooltip>
						</q-btn>
					</q-td>
				</q-tr>
			</template>
		</q-table>

		<q-modal
			v-model="show_test_users"
			:content-css="{ minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '80vh' }"
		>
			<q-modal-layout>
				<q-toolbar slot="header">
					<q-btn flat round dense @click="show_test_users = false" icon="fas fa-times" />
					<q-toolbar-title>
						{{ test.title }}
					</q-toolbar-title>
				</q-toolbar>

				<div class="layout-padding">
					<q-table
						ref="table"
						:data="users"
						:columns="columns_users"
						row-key="user_id"
						:pagination.sync="pagination_users"
						@request="requestUserTests"
						:loading="loading"
						:no-data-label="$t('no_data_avaliable')"
						:no-results-label="$t('no_results_found')"
						:loading-label="$t('loading_data')"
						:rows-per-page-label="$t('items_per_page')"
						:rows-per-page-options="[5, 10, 50, 100]"
						:filter="filter_users"
						binary-state-sort
						class="q-mt-lg"
					>
						<template slot="top" slot-scope="props" :props="props">
							<q-search
								v-model="filter_users"
								icon="fas fa-search"
								:placeholder="$t('search')"
								:debounce="500"
							/>

							<div class="col" />
							<q-btn
								color="secondary"
								v-if="permissions"
								class="q-mr-sm"
								icon="fas fa-download"
								:label="$t('evaluation_report')"
								@click="downloadReportModel()"
							/>
						</template>

						<q-tr slot="header" slot-scope="props" :props="props">
							<q-th v-for="col in props.cols" :key="col.name" :props="props">
								{{ $t(col.label) }}
							</q-th>
						</q-tr>

						<template slot="body" slot-scope="props">
							<q-tr
								:props="props"
								class="cursor-pointer"
								@click.native="showTestUsersResult(props.row)"
							>
								<q-td key="full_name" :props="props">
									{{ props.row.full_name }}
								</q-td>

								<q-td key="email" :props="props">
									{{ props.row.email }}
								</q-td>

								<q-td key="result_date" :props="props">
									{{ fDate(props.row.result_date) }}
								</q-td>
							</q-tr>
						</template>
					</q-table>
				</div>
			</q-modal-layout>
		</q-modal>

		<q-modal
			v-model="show_test_results"
			:content-css="{ minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '80vh' }"
		>
			<q-modal-layout>
				<q-toolbar slot="header">
					<q-btn
						flat
						round
						dense
						@click="show_test_results = false"
						icon="fas fa-times"
					/>
					<q-toolbar-title>
						{{ test.title }}
					</q-toolbar-title>
				</q-toolbar>

				<div class="layout-padding">
					<div class="row gutter-sm justify-end question-list">
						<div
							class="col-xs-12 col-sm-12"
							v-for="(question, index) in test_results"
							:key="index"
						>
							<p
								class="q-subheading text-weight-medium q-mb-xs"
								:id="'qt' + question.id"
							>
								{{ index + 1 }}) {{ question.question }}
							</p>

							<p>{{ question.answer }}</p>
						</div>
					</div>
				</div>
			</q-modal-layout>
		</q-modal>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { date } from 'quasar'
const { formatDate } = date

export default {
	props: ['load', 'id', 'permissions'],

	data() {
		return {
			pagination_tests: {
				page: 1,
				rowsNumber: 10,
				rowsPerPage: null,
				descending: false,
				sortBy: null,
			},
			pagination_users: {
				page: 1,
				rowsNumber: 10,
				rowsPerPage: null,
				descending: false,
				sortBy: null,
			},
			columns_tests: [
				{
					name: 'title',
					required: true,
					label: 'title',
					align: 'left',
					field: 'title',
					sortable: true,
				},
				{
					name: 'qty_questions',
					required: true,
					label: 'questions',
					align: 'left',
					field: 'qty_questions',
					sortable: true,
				},
				{
					name: 'qty_user_results',
					required: true,
					label: 'qty_user_test_results',
					align: 'left',
					field: 'qty_user_results',
					sortable: true,
				},
				{
					name: 'status',
					required: true,
					label: 'status',
					align: 'left',
					field: 'status',
					sortable: true,
				},
				{
					name: 'actions',
					required: true,
					label: '',
					align: 'left',
					field: 'actions',
					sortable: false,
				},
			],
			columns_users: [
				{
					name: 'full_name',
					required: true,
					label: 'name',
					align: 'left',
					field: 'full_name',
					sortable: true,
				},
				{
					name: 'email',
					required: true,
					label: 'email',
					align: 'left',
					field: 'email',
					sortable: true,
				},
				{
					name: 'result_date',
					required: true,
					label: 'date',
					align: 'left',
					field: 'result_date',
					sortable: true,
				},
			],
			tests: [],
			users: [],
			test: {},
			test_result: [],
			test_results: [],
			show_test_users: false,
			show_test_users_result: false,
			show_test_results: false,
			loading: false,
			filter_users: '',
		}
	},

	computed: {
		...mapGetters({
			access_token: 'common/access_token',
			id_user_language_selected: 'common/id_user_language_selected',
			num_rows: 'datatable/num_rows',
		}),

		getHeader() {
			return {
				headers: {
					'content-type': 'application/json',
					authorization:
						'Basic ' +
						btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
					authorization: 'Bearer ' + this.access_token,
				},
			}
		},

		getMaxWidth() {
			return this.$q.platform.is.mobile ? '100vw' : '80vw'
		},

		getMinWidth() {
			if (!this.$q.platform.is.mobile) return '90vw'
		},
	},

	methods: {
		requestTests({ pagination }) {
			this.loading = true
			this.pagination_tests = pagination

			const order = pagination.descending ? '-' : ''
			const order_by = pagination.sortBy ? order + pagination.sortBy : ''

			const data = {
				page_size: this.pagination_tests.rowsPerPage,
				page: this.pagination_tests.page,
				ordering: order_by,
			}

			this.savePaginationTests()

			this.$axios
				.get(
					`/admin_live_classes/live_classes/${this.id}/evaluations/?${this.$qs.stringify(
						data
					)}`,
					this.getHeader
				)
				.then((response) => {
					this.pagination_tests.rowsNumber = response.data.count

					this.tests = response.data.results.map((e) => {
						return { ...e, actions: e.id }
					})
				})
				.catch((e) => {
					console.log(e)
				})
				.finally(() => {
					this.loading = false
				})
		},

		requestUserTests({ pagination }) {
			this.loading = true
			this.pagination_users = pagination

			const order = pagination.descending ? '-' : ''
			const order_by = pagination.sortBy ? order + pagination.sortBy : ''

			const data = {
				page_size: this.pagination_users.rowsPerPage,
				page: this.pagination_users.page,
				ordering: order_by,
				search: this.filter_users,
			}

			this.savePaginationUsers()

			this.$axios
				.get(
					`/admin_live_classes/live_classes/${this.id}/evaluations/${
						this.test.id
					}/results/?${this.$qs.stringify(data)}`,
					this.getHeader
				)
				.then((response) => {
					this.pagination_users.rowsNumber = response.data.count

					this.users = response.data.results.map((e) => {
						return { ...e }
					})
				})
				.catch((e) => {
					console.log(e)
				})
				.finally(() => {
					this.loading = false
				})
		},

		showTestUsers(row) {
			this.test = row
			this.show_test_users = true

			this.requestUserTests({
				pagination: this.pagination_tests,
			})
		},

		showTestUsersResult(row) {
			if (row.id && row.result_date != null) {
				this.$q.loading.show()

				this.$axios
					.get(
						`/admin_live_classes/live_classes/${
							this.id
						}/evaluations/${this.test.id}/evaluation_result_user/${
							row.id
						}/`,
						this.getHeader
					)
					.then((response) => {
						this.test_results = response.data.map((e) => {
							return {
								answer: e.answer,
								question: e.question,
								question_type: e.question_type,
								question_type_id: e.question_type_id,
							}
						})

						this.show_test_results = true
					})
					.catch((e) => {
						console.log(e)
					})
					.finally(() => {
						this.$q.loading.hide()
					})
			}
		},

		getQuestionClass(index, question) {
			let return_class = ''
			if (index != 0) return_class += 'q-mt-md'
			if (question.error) return_class += ' text-negative'
			return return_class
		},

		downloadReportModel() {
			let message = this.$t('generating_import_file_message')
			this.$q.loading.show({
				message,
			})

			this.$axios
				.get(
					`/admin_live_classes/live_classes/${this.id}/evaluations/${
						this.test.id
					}/generate_report/`,
					this.getHeader
				)
				
				.then((response) => {
					this.forceFileDownload(response.data.path_url)
				})
				.catch((e) => {
					this.loading = false
					console.log(e)
				})
				.finally(() => {
					this.$q.loading.hide()
				})
		},

		forceFileDownload(response) {
			const link = document.createElement('a')
			link.href = response
			document.body.appendChild(link)
			link.click()
		},

		fDate(d) {
			if (d) {
				let format = ''

				switch (this.id_user_language_selected) {
					case 1:
					case 3:
						format = 'DD/MM/YYYY HH:mm:ss'
						break
					default:
						format = 'MM-DD-YYYY HH:mm:ss'
						break
				}

				return date.formatDate(d, format)
			}
		},

		getTextStatusTest(status) {
			if (status == 1) return 'published_f'
			else if (status == 2) return 'unpublished_f'
			else if (status == 3) return 'deleted'
		},

		getColorStatusTest(status) {
			if (status === 1) return 'positive'
			else if (status === 2) return 'warning'
			else if (status === 3) return 'negative'
		},

		getIconStatusTest(status) {
			if (status === 1) return 'fas fa-check'
			else if (status === 2) return 'fas fa-ban'
			else if (status === 3) return 'fas fa-times'
		},

		savePaginationTests() {
			this.$store.dispatch('datatable/SET_NUM_ROWS', [this.pagination_tests.rowsPerPage])
		},

		savePaginationUsers() {
			this.$store.dispatch('datatable/SET_NUM_ROWS', [this.pagination_users.rowsPerPage])
		},

		loadPagination() {
			this.pagination_tests.rowsPerPage = this.num_rows
			this.pagination_users.rowsPerPage = this.num_rows
		},
	},

	watch: {
		load: function() {
			if (this.load) {
				this.requestTests({ pagination: this.pagination_tests })
			}
		},

		num_rows: {
			handler: function(newValue) {
				this.loadPagination()
			},
			deep: true,
		},
	},

	created() {
		this.loadPagination()

		this.requestTests({ pagination: this.pagination_tests })
	},
}
</script>

<style></style>
